/**
 * @file outward-report.tsx
 * @module app/modules/finance-reports/outward-report
 * @description Outward report view using the finance sales report layout and summaries.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.4.2
 */

import FinanceSalesReport from './finance-sales-report';

const OutwardReport = () => {
  return (
    <FinanceSalesReport
      reportTitle="Outward Report"
      viewModeStorageKey="outwardReport-viewMode"
      exportSheetName="Outward Report"
      exportFileNamePrefix="Finance-Outward-Report"
      hideDeliveredQty={true}
      hideReturnedQty={true}
      isOutward={true}
    />
  );
};

export default OutwardReport;